export default __webpack_public_path__ + "static/media/Background 5_00069.d2dfde88.png";